import type { AdData } from "@mobility-item-page/types";
import { createContext, useContext } from "react";

/**
 * This React Context provides the data fetched from the "adviewProvider" endpoint
 */
const AdViewContext = createContext<AdData | undefined>(undefined);

type Props = {
  children: React.ReactNode;
  adData?: AdData;
};

export function AdViewProvider(props: Props) {
  const { children, adData } = props;

  return <AdViewContext value={adData}>{children}</AdViewContext>;
}

function useAdView() {
  const context = useContext(AdViewContext);
  if (typeof context === "undefined") {
    throw new Error("useAdView must be used within an AdViewProvider");
  }
  return context;
}

export function useAdViewAd() {
  const context = useAdView();
  return context.ad;
}

export function useAdViewMeta() {
  const context = useAdView();
  return context.meta;
}
